"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ObjectStorageCache = void 0;

var _utils = require("./utils");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var ObjectStorageCache =
/*#__PURE__*/
function () {
  function ObjectStorageCache() {
    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var persistence = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, ObjectStorageCache);

    if (!persistence.storage) {
      throw new _utils.InStorageCacheError('You must provide a persistence.storage to use');
    }

    if (!(0, _utils.validStorage)(persistence.storage)) {
      throw new _utils.InStorageCacheError('You must provide a valid persistence.storage to use');
    }

    if (typeof persistence.normalize !== 'function') {
      throw new _utils.InStorageCacheError('You must provide a persistence.normalize function');
    }

    if (typeof persistence.denormalize !== 'function') {
      throw new _utils.InStorageCacheError('You must provide a persistence.denormalize function');
    }

    if (typeof persistence.shouldPersist !== 'function') {
      throw new _utils.InStorageCacheError('You must provide a persistence.shouldPersist function');
    }

    if (typeof persistence.prefix !== 'string') {
      throw new _utils.InStorageCacheError('You must provide a persistence.prefix string');
    }

    this.persistence = persistence;
    this.data = _objectSpread({}, data);
  }

  _createClass(ObjectStorageCache, [{
    key: "toObject",
    value: function toObject() {
      var persisted = (0, _utils.toObject)(this.persistence.storage, this.persistence.denormalize, this.persistence.prefix);
      return _objectSpread({}, persisted, {}, this.data);
    }
  }, {
    key: "get",
    value: function get(dataId) {
      if (!this.data[dataId] && this.persistence.shouldPersist('get', dataId)) {
        this.data[dataId] = this.persistence.denormalize(this.persistence.storage.getItem("".concat(this.persistence.prefix).concat(dataId)));
      }

      return this.data[dataId];
    }
  }, {
    key: "set",
    value: function set(dataId, value) {
      if (this.persistence.shouldPersist('set', dataId, value)) {
        this.persistence.storage.setItem("".concat(this.persistence.prefix).concat(dataId), this.persistence.normalize(value));
      }

      this.data[dataId] = value;
    }
  }, {
    key: "delete",
    value: function _delete(dataId) {
      if (this.persistence.shouldPersist('delete', dataId)) {
        this.persistence.storage.removeItem("".concat(this.persistence.prefix).concat(dataId));
      }

      this.data[dataId] = undefined;
    }
  }, {
    key: "clear",
    value: function clear() {
      this.persistence.storage.clear();
      this.data = {};
    }
  }, {
    key: "replace",
    value: function replace(newData) {
      this.data = {};

      for (var dataId in newData) {
        this.set(dataId, _objectSpread({}, this.get(dataId), {}, newData[dataId]));
      }
    }
  }]);

  return ObjectStorageCache;
}();

exports.ObjectStorageCache = ObjectStorageCache;